export function getDeleteDateiEndpoint(dateiId) {
    return "/datei/" + dateiId;
}

export function getDateiDownloadDateiEndpoint(dateiId) {
    return "/datei/" + dateiId;
}
